/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-01 14:13:16
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-01 14:13:30
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/ProductSet/tools/advancedPrice.ts
 */
import _ from 'lodash';
export const checkAdvancedPrice = (advancedPriceSettings) => {
  const data = _.cloneDeep(advancedPriceSettings || []);
  let flag = false;
  data.forEach((i) => {
    const { title, price, currency } = i || {};
    if (!title) {
      i.titleError = true;
      flag = true;
    }
    if (!price) {
      i.priceError = true;
      flag = true;
    }
    if (!currency) {
      i.currencyError = true;
      flag = true;
    }
  });
  return { flag, data };
};
